<template>
  <form
    @submit.prevent="formValidate"
    novalidate
    autocomplete="off"
    class="form form-update-password"
  >
    <transition name="fade">
      <div
        v-if="errorMessage"
        class="form-row"
      >
        <div class="form-error q-py-sm text-negative">
          {{ errorMessage }}
        </div>
      </div>
    </transition>

    <q-input
      v-model="form.oldPassword"
      v-validate="getVValidate('required')"
      :error="errors.has('password')"
      filled
      stack-label
      no-error-icon
      color="black"
      name="password"
      label="Password"
      type="password"
      autocomplete="current-password"
      hide-bottom-space
    >
      <template v-slot:error>
        <ul class="list-errors">
          <li
            v-for="(error, errorKey) in passwordErrors"
            :key="errorKey"
            v-html="error"
          />
        </ul>
      </template>
    </q-input>
    <q-input
      ref="newPassword"
      v-model="form.newPassword"
      v-validate="getVValidate('required')"
      :error="errors.has('newPassword')"
      filled
      stack-label
      no-error-icon
      color="black"
      name="newPassword"
      label="New Password"
      type="password"
      autocomplete="new-password"
      hide-bottom-space
    >
      <template v-slot:error>
        <ul class="list-errors">
          <li
            v-for="(error, errorKey) in newPasswordErrors"
            :key="errorKey"
            v-html="error"
          />
        </ul>
      </template>
    </q-input>
    <q-input
      v-model="form.confirmNewPassword"
      v-validate="getVValidate('required|confirmed:newPassword')"
      :error="errors.has('confirm')"
      filled
      stack-label
      no-error-icon
      color="black"
      name="confirm"
      label="Confirm New Password"
      type="password"
      autocomplete="new-password"
      hide-bottom-space
    >
      <template v-slot:error>
        <ul class="list-errors">
          <li
            v-for="(error, errorKey) in confirmNewPasswordErrors"
            :key="errorKey"
            v-html="error"
          />
        </ul>
      </template>
    </q-input>
    <div class="form-actions">
      <div class="form-row">
        <q-btn
          :label="$t('buttons.save')"
          :loading="isProcessing"
          color="secondary"
          text-color="white"
          type="submit"
        />
        <q-btn
          :label="$t('buttons.cancel')"
          @click="cancel"
          outline
          text-color="secondary"
        />
      </div>
    </div>
  </form>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import FormBase from './FormBase';

@Component({
  name: 'form-update-password',
  extends: FormBase,
})
export default class FormUpdatePassword extends Vue {
  form = {
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  };

  get passwordErrors() {
    return this.getErrorMessages('password', 'Current Password');
  }
  get newPasswordErrors() {
    return this.getErrorMessages('newPassword', 'New Password');
  }
  get confirmNewPasswordErrors() {
    return this.getErrorMessages('confirm', 'Confirm New Password');
  }

  cancel() {
    if (this.isFormDirty) {
      this.$q
        .dialog({
          title: 'Confirm',
          message: 'Are you sure?',
          cancel: true,
          persistent: true,
        })
        .onOk(() => {
          this.$emit('cancel');
        });
    } else {
      this.$emit('cancel');
    }
  }
}
</script>
